import ResourceGrid from "./ResourceGrid.vue"
import ResourceTable from "./ResourceTable.vue"
import ResourceUploader from "./ResourceUploader.vue"
import {downloadUseForm} from "../../../../common-components/src/utils/fileUtil";
import ImageViewer from "../../../../common-components/src/components/ImageViewer/image-viewer.vue"
import AudioView from "@/views/preview/AudioPreview.vue"
import {resolveCategoryType, fetchItemIndexById} from "@/utils/resUtil";
import ResourceSelect from "./ResourceSelect.vue";
import {fetchItemById} from "../../utils/resUtil";

let vm
export default {
  name: "resourceContent",
  components: {
    ResourceGrid,
    ResourceTable,
    ResourceUploader,
    ImageViewer,
    AudioView,
    ResourceSelect
  },
  beforeCreate() {
    vm = this
  },
  data() {
    return {
      parentId: 0,
      categoryType:0,
      queryParams: {
        parentId: 0,
        key: ''
      },
      viewMode:'list', // grid list
      resSortType: 'lastModifiedDate',
      resSortOrder: 'descending',
      addDirOptItem: {id: 0, st: 0},
      resourceEditModeType: 0, // 0正常  1 单选 2多选
      parentNameCache: {},
      type: this.$route.params.type ? this.$route.params.type : 0, //0.全部 1.文档 2.图片 3.音频 4.视频 5.其他
      fileName: '', // 搜索用-文件名
      searchHistory: [], // ['书法', '课件', '材料', '欧楷系列讲座材料', '视频'],
      searchHistoryVisible: false, // 搜索历史记录弹窗展示标识
      readonlyFlag: false, // 搜索框只读标识
      catalogPath: [], // ['书法课', '第一章课件', '第二章课件'], // 目录路径
      fileData: [], // 网盘文件
      checkAll: false, // 全选状态标识
      dropVisible: false, // 拖动上传区域展示标识
      showAudio: false,
      previewFileName: undefined,
      fromPc: sessionStorage.getItem("fromPc"),
      packItemList: [], //打包下载
      showPackList: false, //是否显示详情
      audioProgress:0,
      showAudioProgress:false
    };
  },
  created() {
    window.resourceContentVue = this;
    let _this = this;
    // window.addEventListener('keypress', (e) => {
    //   _this.keyPress(e)
    // });
    document.addEventListener('keydown', (e) => {
      _this.keyDown(e)
    });
    document.addEventListener('scroll', this.handleScroll, true);
  },
  watch: {
    $route(){
      console.log('watch', this.$route.path, new Date())
      this.init(false);
    }
  },
  // 路由跳转确认
  beforeRouteLeave(to, from, next) {
    // 判断是否还有正在上传的文件
    if(vm.$refs.resourceUploader.$refs.uploader.uploader.isUploading()){
      const answer = window.confirm("系统可能不会保存您所做的更改。");
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
    next();
  },
  mounted() {
    console.log('mounted', this.$route.path, new Date())
    window.addEventListener("storage",(e)=>{
      console.log("触发预览删除")
      if(e.key&&e.key=='preview_delete_info'){
        this.$message.success("文件删除成功")
        this.queryFiles();
      }
    },false);

    window.onbeforeunload = function(e) {
      if (vm.$refs.resourceUploader.$refs.uploader.uploader.isUploading()) {
        e = e || window.event
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = "系统可能不会保存您所做的更改。"
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "系统可能不会保存您所做的更改。"
      } else {
        window.onbeforeunload = null
      }
    }

    this.init(true);
  },
  computed: {
    // 初始化uploader实例
    uploader() {
      return vm.$refs.uploader.uploader
    },
    catalogPathComp() {
      return this.catalogPath.filter(function (data, index) {
        data.realIndex = index;
        return index != 0 && (vm.catalogPath.length <= 4 || index > (vm.catalogPath.length - 4));
      })
    }
  },
  filters: {

  },
  methods: {
    handleMouseDown(e) {
      this.$refs.tableResSelect.handleMouseDown(e)
    },
    handleScroll(e){
      let _thisDom = e.srcElement;
      if(!_thisDom){
       console.log("监听滚动条失效")
       return
      }

      // 滚动距离
      let scrollTop = _thisDom.scrollTop 
      // 变量windowHeight是可视区的高度
      let windowHeight = _thisDom.clientHeight 
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = _thisDom.scrollHeight 
      if (scrollHeight-(scrollTop + windowHeight) <=50 ) { //小于音频高度时
          if(this.$refs.aduioViewer){
            if(this.showAudio){
              this.showAudioProgress=true;
            }
            this.showAudio=false;
          //  this.$refs.aduioViewer.closeAudio();
          }
      }
    },
    showAudioClick(){//点击音频进度条热区，展示音频插件
      this.showAudio=true;
      this.showAudioProgress=false;
    },
    handleDomSelect(selectIds) {
      if(typeof(selectIds) == "undefined") {
        return;
      }
      // console.log('handleDomSelect resContent', selectIds, new Date())
      let ids = this.getMultipleSelectionIds()
        for(let i = 0;i<selectIds.length; i++) {
          if(ids.indexOf(selectIds[i]) == -1 && ids.indexOf(''+selectIds[i]) == -1) {
            ids.push(selectIds[i])
          }
        }
        // console.log('handleDomSelect resetMultipleSelection', ids, new Date())
      this.resetMultipleSelection(ids)
    },
    fetchFileListRefElement() {
      return (this.viewMode == 'grid') ? this.$refs.resourceGrid : this.$refs.resourceTable;
    },
    getMultipleSelectionIds() {
      try {
        let refElement = this.fetchFileListRefElement();
        return refElement && refElement.getMultipleSelectionIds();
      } catch (e) {
        console.error(e)
      }
      return [];
    },
    resetMultipleSelection(ids) {
      try {
        let refElement = this.fetchFileListRefElement();
        refElement && refElement.resetMultipleSelection(ids)
      } catch (e) {
        console.error(e)
      }
      return false;
    },
    gotoDir(row) {
      try {
        let refElement = this.fetchFileListRefElement();
        refElement && refElement.gotoDir(row);
      } catch (e) {
        console.error(e)
      }
    },
    keyPress(e) {
      let evtobj = e ? e : event
      // console.log('keypress', evtobj.keyCode, new Date());
      if (evtobj.keyCode == 26 && evtobj.ctrlKey) {
        // this.handleCtrlZ(e)
      }
    },
    keyDown(e) {
      let evtobj = e ? e : event
      // console.log('keyDown', evtobj.keyCode, event.target.tagName, event.target.type, new Date());
      if(evtobj.keyCode == 13) {
        if (event.target.tagName === 'INPUT' && event.target.type != 'checkbox') return false;
        this.handleEnterKey()
      } else if(evtobj.keyCode == 90) {
        this.handleCtrlZ(e)
      } else if(evtobj.keyCode >= 37 && evtobj.keyCode <= 40) {
        if (event.target.tagName === 'INPUT') return false;
        this.handleDirectionKey(evtobj)
      }
    },
    handleEnterKey() {
      let ids = this.getMultipleSelectionIds()
      if (typeof (ids) == "undefined" || ids == null || ids.length != 1) {
        return false;
      }
      let row = this.fetchFileItemById(ids[0])
      if (typeof (row) != "undefined" && row != null) {
        this.gotoDir(row)
      }
    },
    fetchFileItemById(id) {
      return fetchItemById(this.fileData, id);
    },
    fetchFileItemIndexById(id) {
      return fetchItemIndexById(this.fileData, id);
    },
    handleDirectionKey(evtobj) {
      let ids = this.getMultipleSelectionIds()
      if (typeof (ids) == "undefined" || ids == null || ids.length > 1) {
        return false;
      }
      const id = ids[0]
      if(evtobj.keyCode == 38) { // 上
        this.handleDirectionKeyUp(id)
      } else if(evtobj.keyCode == 40) { // 上
        this.handleDirectionKeyDown(id)
      } else if(evtobj.keyCode == 37) { // 左
        this.handleDirectionKeyLeft(id)
      } else if(evtobj.keyCode == 39) { // 右
        this.handleDirectionKeyRight(id)
      }
    },
    handleDirectionKeyUp(id) {
      if(this.viewMode == 'grid') {
        let refElement = this.fetchFileListRefElement();
        const rowNumber = refElement && refElement.fetchPerRowNumber()
        this.switchSelectOneItem(id, -1 * rowNumber)
      } else {
        this.selectPrevFileItem(id)
      }
    },
    handleDirectionKeyDown(id) {
      if(this.viewMode == 'grid') {
        let refElement = this.fetchFileListRefElement();
        const rowNumber = refElement && refElement.fetchPerRowNumber()
        this.switchSelectOneItem(id,  rowNumber)
      } else {
        this.selectNextFileItem(id)
      }
    },
    handleDirectionKeyLeft(id) {
      if(this.viewMode == 'grid') {
        this.selectPrevFileItem(id)
      }
    },
    handleDirectionKeyRight(id) {
      if(this.viewMode == 'grid') {
        this.selectNextFileItem(id)
      }
    },
    selectPrevFileItem(id) {
      this.switchSelectOneItem(id, -1)
    },
    selectNextFileItem(id) {
      this.switchSelectOneItem(id, 1)
    },
    selectPrevRowFileItem(id) {
      console.log(id)
    },
    selectNextRowFileItem(id) {
      let refElement = this.fetchFileListRefElement();
      const rowNumber = refElement && refElement.fetchPerRowNumber()
      // console.log('selectPrevRowFileItem', rowNumber, new Date())
      this.switchSelectOneItem(id, rowNumber)
    },
    switchSelectOneItem(id, offset) {
      let findIndex = this.fetchFileItemIndexById(id)
      let targetIndex = (findIndex < 0) ? 0 : (findIndex + offset)
      if(offset > 0 && targetIndex >= this.fileData.length) {
        targetIndex = this.fileData.length - 1;
      }
      if (targetIndex >= 0 && targetIndex < this.fileData.length) {
        let targetRow = this.fileData[targetIndex]
        if (typeof (targetRow) != "undefined" && targetRow != null) {
          this.resetMultipleSelection([targetRow.id])
        }
      }
    },
    handleCtrlZ(e) {
      let editBackButtons = document.querySelectorAll('.notification-edit-back');
      if(editBackButtons.length == 0 || editBackButtons[0].getAttribute("disabled") != null) {
        return;
      }
      e.preventDefault()
      console.log('handle Ctrl+z new', e.keyCode, new Date());
      editBackButtons[0].setAttribute("disabled", "disabled")
      if(editBackButtons.length > 0) {
        editBackButtons[0].click()
      }
    },
    init(fromMounted) {
      if(typeof (fromMounted) == "undefined" || fromMounted == null) {
        fromMounted = true;
      }
      if(fromMounted) {
        this.initSearchHistory()
      }
      let path = this.$route.path
      this.parentId = 0
      const newCategoryType = resolveCategoryType(path)
      // console.log('newCategoryType=', newCategoryType, 'oldCategoryType', this.categoryType, new Date())
      if(newCategoryType ===  this.categoryType) {
        this.toRootDir()
      } else {
        this.fileName = ''
        if('key' in this.queryParams) {
          delete this.queryParams['key'];
        }
        this.categoryType = newCategoryType
        this.fetchCataLogPathList()
        this.queryFiles()
      }
    },
    toggleViewMode() {
      if (this.viewMode == 'list') {
        let ids = this.$refs.resourceTable.getMultipleSelectionIds()
        if(this.$refs.resourceGrid.toggleViewMode('grid', ids)) {
          this.$refs.resourceTable.quitViewMode()
          this.viewMode = 'grid'
        }
      } else {
        let ids = this.$refs.resourceGrid.getMultipleSelectionIds()
        if(this.$refs.resourceTable.toggleViewMode('list', ids)) {
          this.$refs.resourceGrid.quitViewMode()
          this.viewMode = 'list'
        }
      }
    },
    getParams() {
      let params = {};
      try {
        for (let paramName in this.queryParams) {
          let paramValue = this.queryParams[paramName];
          if (paramName == 'key') {
            if(paramValue !=  null && paramValue != '') {
              params[paramName] = paramValue;
            }
          } else {
            params[paramName] = paramValue;
          }
        }
        if (params.orderField != null || params.orderField != null) {
          if (params.orderType == -1 || params.orderField == '') {
            if ('orderType' in params) {
              delete params.orderType;
            }
            if ('orderField' in params) {
              delete params.orderField;
            }
          }
        }
      } catch (t) {
        console.error(t);
      } finally {
        params.parentId = this.parentId;
        if(this.categoryType > 0) {
          params.type = this.categoryType;
        }
      }
      return params;
    },
    resetParentId(newParentId) {
      try {
        this.parentId = newParentId;
        this.queryParams.parentId = this.parentId
        if ('key' in this.queryParams) {
          delete this.queryParams.key;
        }
        if(newParentId == 0) {
          this.catalogPath = [{'parentId': 0, 'name': '全部文件'}]
        }
      } catch (e) {
        console.error(e, new Date());
      }
    },
    toRootDir() {
      this.catalogPath = [{'parentId': 0, 'name': '全部文件'}]
      this.resetParentId(0)
      this.queryFiles();
    },
    backToParent() {
      if (this.catalogPath != null) {
        if (this.catalogPath.length >= 2) {
          const backIndex = this.catalogPath.length - 2;
          this.switchCatoLogPath(this.catalogPath[backIndex], backIndex)
        } else {
          this.toRootDir()
        }
      }
    },
    switchCatoLogPath(item, index) {
      if (index > (this.catalogPath.length - 1)) {
        return;
      }
      // console.log('switchCatoLogPath', item, index, new Date())
      const newParentId = item['parentId'];
      this.resetParentId(newParentId)
      this.queryFiles();
      this.fetchCataLogPathList(item)
    },
    fetchCataLogPathList(item) {
      // console.log('fetchCataLogPathList', item, new Date())
      let reloadFromDB = false;
      let catalogPathList = [{'parentId': 0, 'name': '全部文件'}];
      try {
        if (typeof (item) == 'undefined') {
          return reloadFromDB;
        }
        if (typeof (item.path) == 'undefined' || item.path == null || item.path == '-1' || item.path == -1) {
          reloadFromDB = true;
          return reloadFromDB;
        }
        if (item.path != '0') {
          let ids = item.path.split(',')
          if (ids.length > 0) {
            for (let i = 0; i < ids.length; i++) {
              let id = ids[i];
              if (id in this.parentNameCache) {
                let pathItem = this.parentNameCache[id];
                catalogPathList.push(pathItem)
              } else {
                reloadFromDB = true;
                return reloadFromDB;
              }
            }
          }
        }
        catalogPathList.push(item)
      } catch (t) {
        console.error(t, new Date())
      } finally {
        // console.log('fetchCataLogPathList2', item, 'reloadFromDB = ',reloadFromDB, catalogPathList, new Date())
        if (reloadFromDB) {
          this.fetchCataLogPathFromDB()
        } else {
          this.catalogPath = catalogPathList;
        }
      }
      return reloadFromDB;
    },
    fetchCataLogPathFromDB() {
      const id = this.parentId;
      const params = {id: id};
      this.$api.get("/resapi/tw/resource-file/queryPathList", {params: params}).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        // console.log('queryPathList', res, new Date());
        let catalogPathList = [{'parentId': 0, 'name': '全部文件'}];
        let pathList = res.data;
        if (pathList) {
          pathList.forEach(row => {
            let pathItem = {'parentId': row.id, 'name': row.name, 'path': row.path}
            catalogPathList.push(pathItem)
            this.parentNameCache[row.id] = pathItem
          });
        }
        this.catalogPath = catalogPathList
      }).catch(error => {
        console.error(error);
      })
    },
    refreshFiles(params) {
      // console.log('refreshFiles', params, new Date())
      if (typeof (params) != "undefined") {
        if ('parentId' in params) {
          const item = params;
          const newParentId = item['parentId'];
          this.resetParentId(newParentId)
          if(newParentId != null && newParentId > 0) {
            this.parentNameCache[newParentId] = item
          }
          this.fetchCataLogPathList(item)
        } else {
          for (let key in params) {
            this.queryParams[key] = params[key];
          }
        }
      }
      this.queryFiles();
    },
    searchHistoryClick(name) {
      this.fileName = name;
      this.searchFiles()
    },
    searchFiles() {
      this.parentId = 0
      if (this.fileName != null && this.fileName != '') {
        this.queryParams.key = this.fileName
        this.updateSearchHistory(this.fileName)
      } else {
        this.resetParentId(0)
      }
      this.queryFiles();
    },
    initSearchHistory() {
      try {
        let userId = localStorage.getItem('userId-authorization')
        if (typeof (userId) != "undefined" && userId != null) {
          let searchHistoryCache = localStorage.getItem('searchHistory-' + userId);
          if (searchHistoryCache && searchHistoryCache.length > 0) {
            let historyList = [];
            let historyArray = null;
            try {
              historyArray = JSON.parse(searchHistoryCache)
            } catch (t1) {
              historyArray = searchHistoryCache.split(',')
            }
            historyArray.forEach(row => {
              if (row != null && row != '' && historyList.length < 5) {
                historyList.push(row)
              }
            })
            this.searchHistory = historyList
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    updateSearchHistory: function (name) {
      if (this.searchHistory == null || this.searchHistory.length == 0) {
        this.searchHistory = [name];
      } else {
        let findIndex = this.searchHistory.indexOf(name);
        if (findIndex == -1) {
          this.searchHistory.unshift(name)
          if (this.searchHistory.length > 5) {
            this.searchHistory.splice(5, 1)
          }
        } else {
          this.searchHistory.splice(findIndex, 1)
          this.searchHistory.unshift(name)
        }
      }
      let userId = localStorage.getItem('userId-authorization')
      if (typeof (userId) != "undefined" && userId != null) {
        localStorage.setItem('searchHistory-' + userId, JSON.stringify(this.searchHistory))
      }
    },
    resetResSortType(code, order) {
      this.resSortType = code;
      this.resSortOrder = order;
    },
    switchResSortType(code) {
      let order = 'ascending';
      if (code != this.resSortType) {
        order = 'ascending'
      } else {
        order = (this.resSortOrder == 'descending' ? 'ascending' : 'descending')
      }
      this.resSortType = code;
      this.$refs.resourceTable.switchResSortType(code, order)
    },
    queryFiles(showLoading) {
      if (typeof (showLoading) == "undefined" || showLoading == null) {
        showLoading = true;
      }
      let params = this.getParams();
      params.parentId = this.parentId;
      if (showLoading) {
        this.ucloading.showLoading();
      }
      this.$api.get("/resapi/tw/resource-file/queryFiles", {params: params}).then(res => {
        if (showLoading) {
          this.ucloading.hideLoading();
        }
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        // console.log(res, new Date());
        this.fileData = res.data;
        this.afterQueryFiles()
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
      })
      this.changeResEditModeType(0)
    },
    afterQueryFiles() {
      this.$nextTick(() => {
        this.$refs.resourceTable.afterQueryFiles()
        this.$refs.resourceGrid.afterQueryFiles()
      })
    },
    download(ids) {
      vm.ucloading.showLoading();
      let idsStr = ids.join(',');
      this.$api.post("/resapi/resource/download/downloadCheck", {ids: idsStr}).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          vm.$message.error(res.info);
          return;
        }
        if(res.data.useCompressServer){
          vm.doPackReportFile(res.data.downloadUrl);
        }else{
          downloadUseForm(res.data.downloadUrl, {});
        }
      }).catch(error => {
        vm.ucloading.hideLoading();
        console.log(error);
      })
    },
    doPackReportFile(url) {
      vm.$root.$emit('doPackReportFile', url);
    },
    multipleDownload() {
      if(this.viewMode == 'grid') {
        this.$refs.resourceGrid.multipleDownload()
      } else {
        this.$refs.resourceTable.multipleDownload()
      }
    },
    multipleMove() {
      if(this.viewMode == 'grid') {
        this.$refs.resourceGrid.multipleMove()
      } else {
        this.$refs.resourceTable.multipleMove()
      }
    },
    multipleDelete() {
      if(this.viewMode == 'grid') {
        this.$refs.resourceGrid.multipleDelete()
      } else {
        this.$refs.resourceTable.multipleDelete()
      }
    },
    enterAddDir() {
      // console.log('content enterAddDir', this.parentId, new Date())
      if(this.viewMode == 'grid') {
        this.$refs.resourceGrid.enterAddDir(this.parentId)
      } else {
        this.$refs.resourceTable.enterAddDir(this.parentId)
      }
    },
    changeResEditModeType(type) {
      this.resourceEditModeType = type;
    },
    // "上传文件"按钮
    uploadFiles: function (flag) {
      if (flag) {
        vm.$refs.resourceUploader.$refs.uploadDirBtn.$el.click()
      } else {
        console.log("vm.$refs.resourceUploader", vm.$refs.resourceUploader)
        console.log("vm.$refs.resourceUploader.$refs", vm.$refs.resourceUploader.$refs)
        console.log("vm.$refs.resourceUploader.$refs.uploadBtn", vm.$refs.resourceUploader.$refs.uploadBtn)
        vm.$refs.resourceUploader.$refs.uploadBtn.$el.click()
      }
    },

    // 根据文件名模糊搜索文件
    searchFileName() {
    },
    // 文件名-全选按钮点击
    handleCheckAllChange(val) {
      console.log(val)
    },

    // 去文件所在目录
    toDirectory(file) {
      this.name = ""
      this.categoryType = 0
      this.refreshFiles({parentId: file.parentId, 'name': '', 'path': -1})
      if(typeof(window.resourceIndexVue) != "undefined") {
        window.resourceIndexVue.$refs.customMenu.setDefaultSelected('submenu-2');
      }
    },
    previewFile(file) {
      let type = file.fileType;
      vm.updateLastModifyDate(file);
      if (file.transcoding && (file.transcoding == 7 || file.transcoding == 2)) {
        window.open('/#/file-preview?fileId=' + file.id, "_blank")
        return;
      }
      if (typeof (type) != "undefined" && type >= 31 && type <= 60) {
        this.checkPreviewImage(file);
      } else if (typeof (type) != "undefined" && type >= 61 && type <= 90) {
        this.checkPreviewAudio(file);
      } else {
        window.open('/#/file-preview?fileId=' + file.id, "_blank")
      }
    },
    updateLastModifyDate(file) {
      vm.ucloading.showLoading()
      this.$api.post("/resapi/tw/resource-file/updateLastModifyDate", {id: file.id}).then(res => {
        vm.ucloading.hideLoading()
        if (!res.success) {
          return console.log(res.info);
        }
        vm.queryFiles();
      }).catch(res => {
        vm.ucloading.hideLoading()
        console.log(res)
      })
    },
    previewImage(file) {
      const imageList = vm.getImageList(file)
      let urls = []
      for (let i = 0; i < imageList.length; i++) {
        urls.push(imageList[i].previewUrl)
      }
      this.$refs.imageViewer.previewImage(urls.join(','));
    },
    // 获取可预览图片列表
    getImageList(file) {
      let imageList = []
      let index = 1 // 下标
      for (let i = 0; i < vm.fileData.length; i++) {
        const f = vm.fileData[i]
        const type = f.fileType
        // 先排除非图片类型的文件，再排除不能预览的图片
        if((typeof (type) != "undefined" && type >= 31 && type <= 60)
            && (f.transcoding !== undefined && f.transcoding !== 2 && f.transcoding !== 7)) {
          imageList.push(f)
          if(f.id === file.id) {
            index = imageList.length
          }
        }
      }
      // 调整图片列表排序
      if(imageList.length >= index) {
        return imageList.slice(index - 1, imageList.length).concat(imageList.slice(0, index - 1))
      }
      return imageList
    },
    checkPreviewImage(file) {
      vm.ucloading.showLoading()
      this.$api.get("/resapi/tw/resource-file/checkPreviewFile", {params: {id: file.id}}).then(res => {
        vm.ucloading.hideLoading()
        if (!res.success) {
          return vm.$message.error(res.info);
        }
        if (res.data.transStatus == -1) {
          return vm.$message.error("文件已删除");
        }
        vm.previewImage(file);
      }).catch(res => {
        vm.ucloading.hideLoading()
        console.log(res)
      })
    },
    //音频预览
    checkPreviewAudio(file) {
      vm.ucloading.showLoading()
      this.$api.get("/resapi/tw/resource-file/checkPreviewFile", {params: {id: file.id}}).then(res => {
        vm.ucloading.hideLoading()
        if (!res.success) {
          return vm.$message.error(res.info);
        }
        if (res.data.transStatus == -1) {
          return vm.$message.error("文件已删除");
        }
        this.previewFileId = file.id
        this.showAudio = true,
            this.previewFileName = file.fileFullName||file.name
        this.$refs.aduioViewer.playMusic(file.id,file.fileFullName||file.name, res.data.previewUrl)
      }).catch(res => {
        vm.ucloading.hideLoading()
        console.log(res)
      })
    },
    errorAudioInfo(msg){
      this.$message.error(msg)
    },
  }
}
